import { Account } from './Components/Account';
import { BuyboxRules } from './Components/BuyboxRules';
import { Notifications } from './Components/Notifications';
import {ApiIntegration} from './Components/ApiIntegration'

export const TABS = {
  ACCOUNT: 'account',
  BUYBOX_RULES: 'buybox_rules',
  NOTIFICATIONS: 'notifications',
  API: 'api'
};

export const TABS_CONFIG = [
  { key: TABS.ACCOUNT, label: 'Account', component: <Account /> },
  { key: TABS.BUYBOX_RULES, label: 'Buybox rules', component: <BuyboxRules /> },
  {
    key: TABS.NOTIFICATIONS,
    label: 'Notifications',
    component: <Notifications />,
  },
  {
    key: TABS.API,
    label: 'API Integration',
    component: <ApiIntegration />
  }
];
